import React from "react";
import { BarChart3 } from "lucide-react";

export const hasData = (...values) => {
  const check = (v) => {
    if (v === null || v === undefined) return false;
    if (Array.isArray(v)) return v.some(check);
    if (typeof v === "object") return Object.values(v).some(check);
    const n = Number(v);
    return !Number.isNaN(n) && n !== 0;
  };
  return values.some(check);
};

const NoData = ({ message = "No Data Available", className = "" }) => (
  <div
    className={`flex flex-col items-center justify-center gap-2 py-10 text-gray-400 ${className}`}
  >
    <BarChart3 size={28} strokeWidth={1.5} />
    <p className="text-sm font-medium">{message}</p>
  </div>
);

export default NoData;
